import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ChatModelsItem, ThreadItemType} from '../../../interfaces/api/qna';
import {
  ClinicalCaseState,
  MessageItem,
} from '../../../interfaces/reducers/clicicalCase';

const initialState: ClinicalCaseState = {
  presentUsers: [],
  data: [],
  unreadMessages: [],
  isLoading: false,
  isError: false,
  isLastPage: false,
  isMessageError: false,
  isMessageLoading: false,
  streamMessageLoadingId: null,
  status: {},
  page: 1,
  threadId: undefined,
  threads: [],
  models: [],
};

export const clinicalCaseSlice = createSlice({
  name: 'clinicalCase',
  initialState,
  reducers: {
    setClinicalCasePage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setClinicalCaseIsLoading: state => {
      state.isLoading = true;
      state.isError = false;
    },
    setClinicalCaseIsEnd: (state, action: PayloadAction<boolean>) => {
      state.isLastPage = action.payload;
    },
    setClinicalCaseIsFail: state => {
      state.isLastPage = true;
      state.isLoading = false;
      state.isError = true;
    },
    setMessageSuccess: state => {
      state.isMessageLoading = false;
      state.isMessageError = false;
    },
    setMessageIsLoading: state => {
      state.isMessageLoading = true;
      state.isMessageError = false;
    },
    setMessageIsFail: state => {
      state.isMessageLoading = false;
      state.isMessageError = true;
    },
    setClinicalCase: (state, action: PayloadAction<{data: MessageItem[]}>) => {
      state.data = action.payload.data;
      state.isLoading = false;
      state.isError = false;
    },
    setUnreadMessages: (
      state,
      action: PayloadAction<{data: MessageItem[]}>,
    ) => {
      state.unreadMessages = action.payload.data;
    },
    setPresentUsers: (state, action: PayloadAction<{data: string[]}>) => {
      state.presentUsers = action.payload.data;
    },
    setTypingStatus: (
      state,
      action: PayloadAction<{
        status: {userId: number | string; isTyping: boolean};
      }>,
    ) => {
      state.status = action.payload.status;
      state.isLoading = false;
      state.isError = false;
    },
    setCurrentThreadId: (state, action: PayloadAction<string | undefined>) => {
      state.threadId = action.payload;
    },
    setUserThreadsLoading: state => {
      state.isUserThreadsLoading = true;
      state.isUserThreadsError = false;
      state.threads = [];
    },
    setUserThreadsFail: state => {
      state.isUserThreadsLoading = false;
      state.isUserThreadsError = true;
    },
    setUserThreads: (state, action: PayloadAction<Array<ThreadItemType>>) => {
      state.threads = action.payload;
      state.isUserThreadsLoading = false;
      state.isUserThreadsError = false;
    },
    setStreamMessageLoadingId: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.streamMessageLoadingId = action.payload;
    },
    setClinicalCaseModels: (
      state,
      action: PayloadAction<Array<ChatModelsItem>>,
    ) => {
      state.models = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setClinicalCasePage,
  setClinicalCaseIsLoading,
  setClinicalCaseIsEnd,
  setMessageSuccess,
  setClinicalCaseIsFail,
  setClinicalCase,
  setTypingStatus,
  setMessageIsLoading,
  setMessageIsFail,
  setUnreadMessages,
  setPresentUsers,
  setCurrentThreadId,
  setUserThreadsLoading,
  setUserThreadsFail,
  setUserThreads,
  setStreamMessageLoadingId,
  setClinicalCaseModels,
} = clinicalCaseSlice.actions;

export default clinicalCaseSlice.reducer;
